import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WidgetType } from '../../../shared/domain/widget-type.model';
import { PublisherAdUnitRequest } from '../../../shared/domain/publisher-ad-unit-request.model';
import { PublisherStatsService } from '../../shared/services/publishers-stats.service';
import { SnackBarService } from '../../../shared/services/snackbar.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PublisherRequestNewDomainDialogComponent } from './publisher-request-new-domain-dialog.component';
import { BridgeAdUnit } from '../../../shared/domain/bridge-ad-unit.model';
import { GlobalSpinnerService } from '../../../shared/components/loader-service/global-spinner.service';
import { DevicePlacement, DevicePlacementLabels } from '../../../shared/domain/device-placement.model';
import { Principal } from '../../../shared/auth/principal.service';
import { FormControl } from '@angular/forms';
import { AdsTxtStatus } from '../../../shared/domain/adstxt-status.model';
import { SiteGroup } from '../../../shared/domain/client/site-group.model';
import { Domain } from '../../../shared/domain/domain.model';
import { AdTagConfirmDialogComponent } from './ad-tag-confirm-dialog.component';

@Component({
  selector: 'cm-publisher-request-summary',
  templateUrl: './publisher-request-summary.component.html',
  styleUrls: ['./publisher-request-summary.component.scss']
})
export class PublisherRequestSummaryComponent implements OnInit {

  @Input()
  public widgetType: WidgetType;
  @Input()
  public platform: string;

  @Output()
  public requestCanceled: EventEmitter<void> = new EventEmitter();

  public isReplacementUnit;
  public request: PublisherAdUnitRequest = new PublisherAdUnitRequest();

  siteGroupControl = new FormControl();
  siteGroups: SiteGroup[];
  private replacementAdUnits: BridgeAdUnit[] = [];

  DevicePlacementLabels = DevicePlacementLabels;
  allDomains: Domain[];

  constructor(private publishersService: PublisherStatsService,
              private sbs: SnackBarService,
              private globalSpinnerService: GlobalSpinnerService,
              private router: Router,
              private matDialog: MatDialog,
              private principal: Principal,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.publishersService.productsSummaryApprovedDomains(this.principal.publisher.id).subscribe(domains => {
      this.allDomains = domains;
      this.siteGroups = [
        <SiteGroup>{
          name: 'Invalid ads.txt',
          disabled: true,
          sites: domains.filter(d => d.adstxtStatus !== AdsTxtStatus.VALID)
        },
        <SiteGroup>{
          name: 'Valid domains',
          sites: domains.filter(d => d.adstxtStatus === AdsTxtStatus.VALID)
        }
      ];
    });
  };

  public goBack() {
    this.requestCanceled.emit();
  }

  public submit() {
    if (!this.request.domainIds && !this.request.domainIds.length) {
      this.sbs.error('Please select domain');
      return;
    }

    if (!this.principal.publisher.tipaltiPayable) {
      this.sbs.error('Tipalti information is missing');
      return;
    }

    const invalidDomains = this.allDomains.filter(d => this.request.domainIds.includes(d.id) && d.adsTxtMissingRecords > 5);
    if (invalidDomains.length) {
      this.matDialog.open(AdTagConfirmDialogComponent, <MatDialogConfig>{
        data: {
          domains: invalidDomains
        }
      }).afterClosed().subscribe(result => {
        if (result) {
          this.sendRequestToServer();
        }
      });
    } else {
      this.sendRequestToServer();
    }

  }

  private sendRequestToServer() {
    this.globalSpinnerService.showLoader();
    this.request.devicePlacement = <DevicePlacement> this.platform;
    this.publishersService.productsRequestUnit(this.widgetType.id, this.request)
      .subscribe(next => {
          this.router.navigate(['/products-success']);
          this.globalSpinnerService.hideLoader();
        },
        error => {
          this.sbs.error('Error occurred during request submission, please contact our support');
          this.globalSpinnerService.hideLoader();
        });
  }

  public openDomainModal() {
    const ref = this.dialog.open(PublisherRequestNewDomainDialogComponent);
    ref.afterClosed().subscribe(result => {
      if (result) {
        this.request.newDomainUrl = result;
        this.request.domainId = null;
      }
    });
  }

  public chooseAnotherDomain() {
    this.request.newDomainUrl = null;
  }


}

